// EmailJS Configuration
// Replace these values with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_rglvwqd',     // Your Gmail service ID from EmailJS
  TEMPLATE_ID: 'template_cip66a3',   // Your template ID from EmailJS
  USER_ID: 'JY3PH72oc_8n1bR41'    // Your public key from EmailJS Account settings
};

// SETUP INSTRUCTIONS:
// 1. Go to https://www.emailjs.com/
// 2. Email Services → Add Gmail service → Get SERVICE_ID
// 3. Email Templates → Create template → Get TEMPLATE_ID  
// 4. Account → General → Get Public Key (USER_ID)
// 5. Replace the xxx values above with your actual credentials
